export default {
  SINGLE_CONNECTION: 'SINGLE',
  LIST_BRANCH_CONNECTION: 'LIST_BRANCH',
  STATIC_BRANCH_CONNECTION: 'STATIC_BRANCH',
  AB_TEST_BRANCH_CONNECTION: 'AB_TEST_BRANCH',
  WHILE_LOOP: 'WHILE_LOOP'
};